import { render, staticRenderFns } from "./novel.vue?vue&type=template&id=806dc694&scoped=true"
import script from "./novel.vue?vue&type=script&lang=js"
export * from "./novel.vue?vue&type=script&lang=js"
import style0 from "./novel.vue?vue&type=style&index=0&id=806dc694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806dc694",
  null
  
)

export default component.exports